import { render } from "./PayyoSimpleStatusBadge.vue?vue&type=template&id=a78f0758"
import script from "./PayyoSimpleStatusBadge.vue?vue&type=script&lang=js"
export * from "./PayyoSimpleStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__